import React from 'react'

import { palette } from '../../../../styles/variables'
import { Cross } from '../../../icon/Icon'

import { AppBannerCrossStyled } from './styled'

export const AppBannerCross = ({ onClose, theme }) => {
  return (
    <AppBannerCrossStyled theme={theme}>
      <Cross
        onClick={onClose}
        color={palette.white}
        hoverColor={palette.white}
        margin="0"
        position="absolute"
        strokeWidth="2px"
        width="16px"
        height="16px"
      />
    </AppBannerCrossStyled>
  )
}
